import { TableWrapper } from '@components/table'
import appStore from '@stores/appStore'
import { getURLParams, removeAllURLParams } from '@utils/functions'
import { observer } from 'mobx-react'
import { useEffect } from 'react'

import store from './store'
import Table from './Table'
import TableFilter from './TableFilter'

const ClientActiveCount = () => {
  const params: any = getURLParams()

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    removeAllURLParams()

    if (appStore.isHostTenant) {
      await store.fetchTenantsData()
      if (store.tenantsData?.length > 0) {
        store.updateFilter({ ...params, tenantId: store.tenantsData[0].id })
      }
    } else {
      store.updateFilter({ ...params, tenantId: appStore.currentTenant.id })
    }

    store.fetchData()
  }

  return (
    <TableWrapper loading={store.loading && !store.data}>
      <TableFilter />
      <Table />
    </TableWrapper>
  )
}

export default observer(ClientActiveCount)
